var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bt-button",class:[_vm.size, _vm.variant, _vm.type, { disabled: _vm.disabled }, { block: _vm.block }],attrs:{"type":_vm.nativeType},on:{"click":e => _vm.$emit('click', e)}},[(_vm.loading)?_c('bt-loader',{attrs:{"button":true}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }